module.exports = __webpack_public_path__ + "static/logo-f059f4b11668fa814926b8e688d25815.svg";